// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.Text = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _Text = require('./Text.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

var Text = function Text(props) {
  var children = props.children,
    tag = props.tag,
    display = props.display;
  return _react.default.createElement(
    _Text.StyledText,
    _extends({}, props, {
      display: display || (tag === 'p' ? 'block' : 'inline'),
      as: tag
    }),
    children
  );
};
/**
 * Definition of default values for component props
 */

exports.Text = Text;
Text.defaultProps = {
  children: undefined,
  tag: 'span',
  level: 'normal',
  truncate: false,
  color: undefined,
  display: undefined,
  align: 'inherit',
  fontFamily: undefined,
  fontWeight: undefined,
  marginTop: '0',
  marginBottom: undefined
};
Text.propTypes = {
  /** Inner elements into the <h*> tag */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),

  /** The html tag used to wrap the texts */
  tag: _propTypes.default.oneOf(['p', 'span']),

  /** The text level */
  level: _propTypes.default.oneOf(['normal', 'small', 'xSmall', 'xxSmall']),

  /** If true, the text will be truncated with ellipsis fitting the wrapper element width */
  truncate: _propTypes.default.bool,

  /** The text color. If not set, it gets the default normalize color depending on the background darkness-level */
  color: _propTypes.default.string,

  /** The display CSS property for this element. If not selected, it is set to 'block' for <p> and 'inline' for all other tags */
  display: _propTypes.default.oneOf(['initial', 'block', 'inline', 'inline-block']),

  /** The text alignment */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /** The text font family */
  fontFamily: _propTypes.default.string,

  /** The font-weight CSS property */
  fontWeight: _propTypes.default.oneOf([
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    'bold',
    'bolder',
    'lighter',
    'inherit',
    'initial',
    'unset',
    'normal'
  ]),

  /** The margin over of the heading. Include units (px, %, rem, em, ...) */
  marginTop: _propTypes.default.string,

  /** The margin below of the heading. Include units (px, %, rem, em, ...) */
  marginBottom: _propTypes.default.string
};


